import axiosInstance from "../services/api";
import { API_ENDPOINTS } from "../constants/actionTypes";

export const authApi = {
  login: async (userEmail, userPassword, loginType) => {
    // Send the specific keys the backend expects
    const response = await axiosInstance.post(API_ENDPOINTS.LOGIN, {
      userEmail,
      userPassword,
      loginType,
    });
    const data = response.data?.data;
    const token = data?.accessToken;
    const refreshToken = data?.refreshToken;

    // Store raw JWT payload data directly - let Redux slice decode
    localStorage.setItem("authToken", token);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("authUser", JSON.stringify(data));

    return response.data;
  },

  changePassword: async ({ oldPassword, newPassword, confirmPassword }) => {
    const response = await axiosInstance.post(API_ENDPOINTS.CHANGE_PASSWORD, {
      oldPassword,
      newPassword,
      confirmPassword,
    });
    return response.data;
  },

  logout: async () => {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        await axiosInstance.post(
          API_ENDPOINTS.LOGOUT,
          JSON.stringify(refreshToken),
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
      }
    } catch (error) {
      console.error("Logout error details:", error.response?.data);
      throw error;
    } finally {
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
    }
  },
  verifyOtp: async (email, otp) => {
    // Backend expects email and the 6-digit OTP
    const response = await axiosInstance.post(API_ENDPOINTS.VERIFY_OTP, {
      email,
      otp: parseInt(otp), // Ensure OTP is sent as a number if required by backend
      loginType: 0,
    });
    return response.data;
  },

  refreshAccessToken: async () => {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      if (!refreshToken) {
        throw new Error("No refresh token");
      }

      const response = await axiosInstance.post(API_ENDPOINTS.REFRESH_TOKEN, {
        refreshToken,
      });

      const data = response.data?.data;
      const newAccessToken = data?.accessToken;

      if (newAccessToken) {
        localStorage.setItem("authToken", newAccessToken);
        return { accessToken: newAccessToken };
      }
      throw new Error("Refresh failed");
    } catch (error) {
      // Clear all on refresh fail
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("authUser");
      throw error;
    }
  },
};
